import { render } from "./index.vue?vue&type=template&id=241b7d2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=241b7d2a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-241b7d2a"

export default script